"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Header = void 0;
const tslib_1 = require("tslib");
const jsx_runtime_1 = require("react/jsx-runtime");
const Nav_1 = tslib_1.__importDefault(require("react-bootstrap/Nav"));
const Navbar_1 = tslib_1.__importDefault(require("react-bootstrap/Navbar"));
const Link_1 = require("../../link/Link");
const NavItem_1 = require("../../nav/NavItem");
const UI_1 = require("../../UI");
const UserHeaderNav_1 = require("./UserHeaderNav");
const Header = (_a) => {
    var { brand, navItems = [], UserHeaderNavComponent } = _a, navbarProps = tslib_1.__rest(_a, ["brand", "navItems", "UserHeaderNavComponent"]);
    let brandContent = null;
    const { useLink } = UI_1.useUIContext();
    if (brand) {
        if (Link_1.isLinkProps(brand)) {
            const { href } = brand, navbarBrandProps = tslib_1.__rest(brand, ["href"]);
            brandContent = useLink(Object.assign({ href, Component: Navbar_1.default.Brand }, navbarBrandProps));
        }
        else {
            brandContent = useLink({ href: "/", Component: Navbar_1.default.Brand, children: brand });
        }
    }
    if (!UserHeaderNavComponent) {
        UserHeaderNavComponent = UserHeaderNav_1.UserHeaderNav;
    }
    return (jsx_runtime_1.jsxs(Navbar_1.default, Object.assign({ expand: "lg" }, navbarProps, { children: [brandContent, jsx_runtime_1.jsx(Navbar_1.default.Toggle, { "aria-controls": "main-navbar-nav" }, void 0),
            jsx_runtime_1.jsxs(Navbar_1.default.Collapse, Object.assign({ id: "main-navbar-nav" }, { children: [jsx_runtime_1.jsx(Nav_1.default, Object.assign({ className: "mr-auto" }, { children: jsx_runtime_1.jsx(NavItem_1.NavItems, { navItems: navItems }, void 0) }), void 0),
                    jsx_runtime_1.jsx(UserHeaderNavComponent, {}, void 0)] }), void 0)] }), void 0));
};
exports.Header = Header;
//# sourceMappingURL=Header.js.map